import { apiClient } from '@/lib/api-client';
import { API_ROUTES } from '@/lib/api-config';
import type { TattooImage } from '@/types/tattooImage.types';

/**
 * Get all tattoo images (for gallery)
 */
export const getAllTattooImages = async (): Promise<Array<TattooImage>> => {
  return apiClient.get<Array<TattooImage>>(API_ROUTES.TATTOO_IMAGES);
};

/**
 * Get a single tattoo image by ID
 */
export const getTattooImageById = async (id: string): Promise<TattooImage> => {
  return apiClient.get<TattooImage>(API_ROUTES.TATTOO_IMAGE_BY_ID(id));
};
